<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="scss">
    /* Common styles */

    .va-middle {
        vertical-align: middle;
    }

    .bt {
        border-top: solid 1px black;
    }

    /* Display only on printing in summary */
    @media screen {
        .d-print-block {
            display: none;
        }
    }

    /* test styles */

    .bb {
        border: blue 1px solid;
    }

    .br {
        border: red 1px solid;
    }
</style>
